var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"connections"},[(_vm.is.loading)?_c('div',{staticClass:"connections-loading prp-loading"}):_vm._e(),_vm._l((_vm.candidates),function(profile){return _c('com-user',{key:profile.id,attrs:{"profile":profile}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }